import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-dark text-white mt-12 hidden md:block">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl">🔧</span>
              <span className="font-bold text-xl">MotoMarketCR</span>
            </div>
            <p className="text-gray-400 text-sm">
              El marketplace líder de repuestos para motorcycles en Costa Rica. Encuentra lo que necesitas para tu moto.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Categorías</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/products" className="hover:text-primary">Todos los productos</Link></li>
              <li><Link to="/accessories" className="hover:text-primary">Accesorios</Link></li>
              <li><Link to="/consumables" className="hover:text-primary">Consumibles</Link></li>
              <li><Link to="/wants" className="hover:text-primary">Solicitudes</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Ayuda</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/how-to-sell" className="hover:text-primary">Cómo vender</Link></li>
              <li><Link to="/verification" className="hover:text-primary">Verificación de vendedores</Link></li>
              <li><a href="mailto:contacto@arburola.com" className="hover:text-primary">Contacto</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Síguenos</h4>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-primary transition">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-primary transition">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-primary transition">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
            <div className="mt-4 text-sm text-gray-400">
              <p>✉️ contacto@arburola.com</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-white/10 mt-8 pt-8 text-center text-sm text-gray-400">
          © 2025 MotoMarketCR. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
}